import { Helmet } from 'react-helmet-async';
import { useEffect } from 'react';

const Crisp = () => {
  useEffect(
    () => () =>
      document
        .querySelectorAll('#crisp-chatbox, .crisp-client')
        .forEach((element) => element.remove()),
    []
  );

  return (
    <Helmet>
      <script type="text/javascript">
        {`
          window.$crisp = [];
          window.CRISP_WEBSITE_ID = "${process.env.REACT_APP_CRISP_WEBSITE_ID}";
          (function() {
            let d = document;
            let s = d.createElement("script");
            s.src = "https://client.crisp.chat/l.js";
            s.async = 1;
            let head = document.getElementsByTagName("head")[0];
            head.appendChild(s);
           
            function adjustCrispZIndex() {
              let crispElements = document.querySelectorAll("#crisp-chatbox, .crisp-client");
              crispElements.forEach(element => {
                element.style.zIndex = '99'; 
              });
            }
          
            let observer = new MutationObserver((mutations) => {
              mutations.forEach((mutation) => {
                if (mutation.addedNodes.length > 0) {
                  adjustCrispZIndex();
                }
              });
            });

            observer.observe(document.body, {
              childList: true,
              subtree: true
            });
          })();
        `}
      </script>
    </Helmet>
  );
};

export default Crisp;
